import ButtonClickListener from './ButtonClickListener.js';
import FileInputChangeListener from './FileInputChangeListener.js';
import * as THREE from 'three';

import PanelResizeListener from './PanelResizeListener.js';


import Experience from '../Experience.js';




/**
 * Listens to Events in the Experience
 */
export default class GeneralEventListener {
    constructor() {



        this.experience = new Experience();


        //console.log("General Listened")
        document.addEventListener('DOMContentLoaded', () => {
            this.init();
        }); 

    }

    init() {
        

        // Initialize other event listeners
        const buttonClickListener = new ButtonClickListener();
        const fileInputChangeListener = new FileInputChangeListener();
        //const panelResizeListener = new PanelResizeListener();

        //document.addEventListener( 'mousemove', onPointerMove );

    
    }
}

